import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Somos from './pages/Somos';
import Productos from './pages/Productos';
import Contacto from './pages/Contacto';

import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <>
      {/* 🔥 BOTÓN GLOBAL */}
      <WhatsAppButton />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/somos" element={<Somos />} />
        <Route path="/productos" element={<Productos />} />
        <Route path="/contacto" element={<Contacto />} />
      </Routes>
    </>
  );
}

export default App;